module.exports = __webpack_public_path__ + "img/Elli-Fahrzeugschein-VWFS.2860095a.png";